import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { toast } from 'react-toastify';
import { listAgentHolidays } from '../services/listAgentHolidays';
import { deleteAgentHoliday } from '../services/deleteAgentHoliday';
import ModalHolidayForm from './ModalHolidayForm';
import { useSelector } from 'react-redux';
import { staffUsersSelector } from '../../tasks';

enum State {
  LOADING = 'loading',
  IDLE = 'idle',
}
export default function HolidayList() {
  const intl = useIntl();
  const [holidays, setHolidays] = useState([]);
  const [state, setState] = useState(State.IDLE);
  const [modalVisible, setModalVisible] = useState(false);
  const staffUsers = useSelector(staffUsersSelector);

  async function fetchHolidays() {
    setState(State.LOADING);
    try {
      const { data } = await listAgentHolidays();
      console.log({ data });
      setHolidays(data);
      setState(State.IDLE);
    } catch (error) {
      toast.error(intl.formatMessage({ id: 'holiday.fetchError' }));
    } finally {
      setState(State.IDLE);
    }
  }

  async function handleDelete(holidayId: number) {
    const confirmed = window.confirm(
      intl.formatMessage({ id: 'holiday.deleteConfirm' })
    );
    if (!confirmed) return;
    try {
      await deleteAgentHoliday(holidayId);
      toast.success(intl.formatMessage({ id: 'holiday.deleteSuccess' }));
      fetchHolidays();
    } catch (error) {
      toast.error(intl.formatMessage({ id: 'holiday.deleteError' }));
      console.warn(error);
    }
  }

  useEffect(() => {
    fetchHolidays();
  }, []);

  return (
    <div className="card p-10">
      <div className="mb-8 d-flex justify-content-between align-items-center">
        <h2>{intl.formatMessage({ id: 'holiday.title' })}</h2>
        <button
          className="btn btn-primary mb-4"
          onClick={() => setModalVisible(true)}
        >
          {intl.formatMessage({ id: 'holiday.addHoliday' })}
        </button>
      </div>
      <main>
        {state === State.LOADING ? (
          <div className="text-center">
            <span className="spinner-border spinner-border-sm text-primary" />
          </div>
        ) : (
          <table className="table table-striped">
            <thead className="fw-bolder">
              <tr>
                <th>{intl.formatMessage({ id: 'holiday.agent' })}</th>
                <th>{intl.formatMessage({ id: 'holiday.workDay' })}</th>
                <th>{intl.formatMessage({ id: 'holiday.startHour' })}</th>
                <th>{intl.formatMessage({ id: 'holiday.endHour' })}</th>
                <th>{intl.formatMessage({ id: 'holiday.reason' })}</th>
                <th>{intl.formatMessage({ id: 'holiday.dayOff' })}</th>
                <th>{intl.formatMessage({ id: 'holiday.actions' })}</th>
              </tr>
            </thead>
            <tbody>
              {holidays.map((holiday) => (
                <tr key={holiday.id}>
                  <td>
                    {`${
                      staffUsers.find((user) => user.id === holiday.user)
                        ?.name || ''
                    } ${
                      staffUsers.find((user) => user.id === holiday.user)
                        ?.last_name || ''
                    } (${
                      staffUsers.find((user) => user.id === holiday.user)
                        ?.email || ''
                    })`}
                  </td>
                  <td>{holiday.work_day}</td>
                  <td>{holiday.start_hour}</td>
                  <td>{holiday.end_hour}</td>
                  <td>{holiday.reason || '-'}</td>
                  <td>
                    {holiday.day_off
                      ? intl.formatMessage({ id: 'holiday.yes' })
                      : intl.formatMessage({ id: 'holiday.no' })}
                  </td>
                  <td>
                    <button
                      className="btn btn-sm btn-light-danger"
                      onClick={() => handleDelete(holiday.id)}
                    >
                      <i className="fas fa-trash-alt me-2" />
                      {intl.formatMessage({ id: 'holiday.delete' })}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </main>
      <ModalHolidayForm
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        onSubmit={() => fetchHolidays()}
      />
    </div>
  );
}
